
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import numberFormats from 'utils/numberFormats'
import classnames from 'classnames'
import Icon from 'components/Icon'

export default class Progress extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    limit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    current: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    barFirst: PropTypes.bool,
    withoutValues: PropTypes.bool,
    currentValueLabel: PropTypes.string,
    totalValueLabel: PropTypes.string,
    width: PropTypes.number
  }

  static defaultProps = {
    current: 0
  }

  render() {
    const {barFirst, className} = this.props
    const classNames = classnames('progress', className)

    if (barFirst) {
      return (
        <div className={classNames}>
          {this.renderBar()}
          {this.renderLimits()}
        </div>
      )
    } else {
      return (
        <div className={classNames}>
          {this.renderLimits()}
          {this.renderBar()}
        </div>
      )
    }
  }

  renderLimits() {
    const {currentValueLabel, totalValueLabel} = this.props

    return (
      <div className='progress_limits'>
        <div className='progress_limits_current'>
          {this.renderCurrentValue()}
          <div className='progress_limits_label'>{currentValueLabel}</div>
        </div>
        <div className='progress_limits_effective'>
          {this.renderTotalValue()}
          <div className='progress_limits_label'>{totalValueLabel}</div>
        </div>
      </div>
    )
  }

  renderCurrentValue() {
    const {current, limit, withoutValues} = this.props

    if (withoutValues) return null

    const isExceeding = limit && current > limit
    const classNames = classnames('progress_limits_value', {
      'is-exceeding': isExceeding
    })

    if (!isExceeding) {
      return (
        <div className={classNames}>
          {numberFormats.number(current)}
        </div>
      )
    }

    return (
      <div className={classNames}>
        {numberFormats.number(current)}
        <Icon className='progress_limits_label_icon' name='warning' size='18px' />
        <span className='progress_limits_note'>
          ({numberFormats.percent(current / limit - 1)} excees)
        </span>
      </div>
    )
  }

  renderTotalValue() {
    const {limit, withoutValues} = this.props

    if (withoutValues) return null

    return (
      <div className='progress_limits_value'>
        {limit ? numberFormats.number(limit) : 'Unlimited'}
      </div>
    )
  }

  renderBar() {
    const {width, current, limit} = this.props
    const ratio = this.getCurrentRatio()
    const currentWidth = (width - 8) * ratio
    const isExceeding = limit && current > limit
    const classNames = classnames('progress_bar', {
      'is-exceeding': isExceeding
    })

    return (
      <div className={classNames}>
        <div className='progress_bar_content'>
          <div className='progress_bar_current' style={{width: currentWidth}}>
            <Icon className='progress_bar_icon' name='drop' size='11px' />
          </div>
          {isExceeding ? <Icon className='progress_bar_warn-icon' name='drop' size='11px' /> : null}
        </div>
      </div>
    )
  }

  getCurrentRatio() {
    const {current, limit} = this.props

    if (!current) return 0

    if (!limit) return 0.5

    if (current < limit) return current / limit

    return limit / current
  }
}



// WEBPACK FOOTER //
// ./client/components/Progress/index.js